import React from "react";
import "./ProjectMonarchContent.css";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AMSEssentials from "./ProjectMonarchTracks/AMSEssentials";
import AMS from "./ProjectMonarchTracks/AMS";
import IMS from "./ProjectMonarchTracks/IMS";
// import Bullet from './Bullet.png';
// import Bullet1 from '../../public/images/Monarch/Bullet.png'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className="tracks-content"
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}


function ProjectMonarchContent() {

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="main-banner">
        <img
          src="images/Monarch/monarch-banner.png"
          alt="banner"
          className="banner-img"
        />
      </div>
      {/* first section */}
      <div className="about-monarch-container">
        <div className="about-monarch-wrap">
          <h2>Project Monarch Objectives</h2>
          <ul>
            <li>Establish a comprehensive project framework to integrate additional accounts within ATC - GN, fostering collaborative efforts between ATC-I and ATC-NA teams.</li>
            <li>Ensure the participation of all identified resources in a standardized training regimen focused on AMS Foundations in both AMS and IMS domains.</li>
            <li>Facilitate the enrollment of resources in a self-paced online AMS beginner course, tailored to enhance skill sets in IMS and AMS ATC-NA counterparts.</li>
            <li>Regularly disseminate progress updates to all program participants, fostering transparency and accountability in the upskilling process.</li>
            <li>Inaugurate the program with a meticulously planned Kick-off call, serving as a catalyst for cross-regional collaboration and knowledge sharing.</li>
          </ul>
        </div>
      </div>
      {/* second section */}
      <div className="program-overview-container">
        <div className="program-overview-wrap">
          <h2>Program Overview</h2>
          <img
            src="images/Monarch/ProgramOverview.png"
            alt="This image explain 3 week monarch learning program"
            className="Infographics-img"
          />
        </div>
      </div>
      {/* third section */}
      {/* <div className="essentials-container">
        <a
          href="https://deepknowledge1.accenture.com/moodle/course/view.php?id=59"
          target="blank"
        >
          <div className="essentials-wrap">
            <div className="essentials-row row1">
              <div className="essentials-box">
                <img
                  src="images/Monarch/ams-img1.png"
                  alt="AMS Essentials"
                  className="ams-tile-img"
                />
              </div>
            </div>
            <div className="essentials-row row2">
              <div className="essentials-box">
                <h3>AMS Essentials for Beginners</h3>
                <p>
                  Welcome to the AMS Essentials for Beginners. This program is
                  designed for CL-13 to CL-11 participants that aims to
                  understand about the Essentials of Application Management
                  Services (AMS) for Beginners. This program covers various
                  aspects like Application Maintenance Overview, understanding
                  of Incident, Service Request, Problem, Change and Event
                  Management, System Monitoring, Service Level Agreement (SLA),
                  and Key Performance Indicator (KPI).
                </p>
                <p className="explore-more">Explore more...</p>
              </div>
            </div>
          </div>
        </a>
      </div> */}

      {/* last section  */}
      <div className="tracks-outer-container">
        <div className="tracks-inner-container expanded">
          <h3 className="tracks-heading">Tracks<div className="track-border-bottom"></div></h3>

          <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 224 }}
          >
            <Tabs
              orientation="vertical"
              // variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              sx={{ borderRight: 1, borderColor: 'divider' }}
            >
              <Tab label="AMS Essentials" {...a11yProps(0)} />
              <Tab label="AMS Stream" {...a11yProps(1)} />
              <Tab label="IMS Stream" {...a11yProps(2)} />

            </Tabs>
            <TabPanel value={value} index={0} >
              <AMSEssentials />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <AMS></AMS>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <IMS />
            </TabPanel>
          </Box>
        </div>
      </div>
    </>
  );
}

export default ProjectMonarchContent;
